import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';

const TeamPage = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const teamMembers = [
    {
      name: 'Mario Marjanovic',
      role: 'Partner | Head of Sustainability',
      image: 'https://customer-assets.emergentagent.com/job_c28bcfec-1f23-4589-898c-e7f2427d711a/artifacts/gx1mgpxf_IMG_0212.jpg',
      position: 'center 15%',
    },
    {
      name: 'Egzon Imeri',
      role: 'Geschäftsführer | Head of Sales',
      image: 'https://customer-assets.emergentagent.com/job_c28bcfec-1f23-4589-898c-e7f2427d711a/artifacts/jbkj2srx_IMG_9845.jpg',
      position: 'center 15%',
    },
    {
      name: 'Stéphane Garcia',
      role: 'Head of Marketing & Communications',
      image: 'https://customer-assets.emergentagent.com/job_c28bcfec-1f23-4589-898c-e7f2427d711a/artifacts/x2x9odq3_IMG_9806.jpg',
      position: 'center 18%',
    },
    {
      name: 'Jannick Chandler',
      role: 'Consultant Nachhaltigkeit',
      image: 'https://customer-assets.emergentagent.com/job_c28bcfec-1f23-4589-898c-e7f2427d711a/artifacts/ed1omf7v_IMG_9772.jpg',
      position: 'center 12%',
    },
    {
      name: 'Axel Schade',
      role: 'Consultant Nachhaltigkeit',
      image: 'https://customer-assets.emergentagent.com/job_c28bcfec-1f23-4589-898c-e7f2427d711a/artifacts/p2ib5uwy_IMG_9785.jpg',
      position: 'center 5%',
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header scrolled={scrolled} isSubPage={true} />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-gray-900 via-gray-800 to-green-900">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2000')] bg-cover bg-center opacity-20"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            Unser Team
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Engagierte Experten für Ihre Klimaziele
          </p>
        </div>
      </section>

      {/* Team Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-8">
            {teamMembers.map((member, index) => (
              <Card 
                key={index} 
                className="overflow-hidden hover:shadow-xl transition-shadow duration-300"
                data-testid={`team-member-${index}`}
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    style={{ imageRendering: 'auto', objectPosition: member.position || 'center top' }}
                    loading="eager"
                  />
                </div>
                <div className="p-4 md:p-5 text-center">
                  <h3 className="text-sm md:text-base font-bold text-gray-900 mb-1">
                    {member.name}
                  </h3>
                  <p className="text-green-600 font-medium text-xs md:text-sm leading-tight">
                    {member.role}
                  </p>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TeamPage;
